import { RouteObject } from "react-router-dom";
import EventAdminView from "../components/Admin/EventAdminView";
import { EventEditorView as EventEditor } from "../components/Admin/EventEditorView";
import PricelistsView from "../components/Admin/PricelistsView";
import EnsureUserIsAuthenticated from "../components/Security/EnsureUserIsAuthenticated";
import AdminDownloadJobDetailPage from "../pages/Admin/AdminDownloadJobDetailPage";
import AdminDownloadJobsPage from "../pages/Admin/AdminDownloadJobsPage";
import ShopAdminPage from "../pages/Admin/Shop/ShopAdminPage";
import SystemConfigAdminPage from "../pages/Admin/SystemConfig/SystemConfigAdminPage";

export const adminRoutes: RouteObject[] = [
    { path: "/admin/events", element: <EnsureUserIsAuthenticated><EventAdminView /></EnsureUserIsAuthenticated> },
    { path: "/admin/events/pricelists", element: <EnsureUserIsAuthenticated><PricelistsView /></EnsureUserIsAuthenticated> },
    { path: "/admin/events/:eventId", element: <EnsureUserIsAuthenticated><EventEditor /></EnsureUserIsAuthenticated> },
    { path: "/admin/shop", element: <EnsureUserIsAuthenticated><ShopAdminPage /></EnsureUserIsAuthenticated> },
    { path: "/admin/systemconfig", element: <EnsureUserIsAuthenticated><SystemConfigAdminPage /></EnsureUserIsAuthenticated> },
    { path: "/admin/download-jobs", element: <EnsureUserIsAuthenticated><AdminDownloadJobsPage /></EnsureUserIsAuthenticated> },
    { path: "/admin/download-jobs/:jobId", element: <EnsureUserIsAuthenticated><AdminDownloadJobDetailPage /></EnsureUserIsAuthenticated> },
];
